import { Box } from '@mui/material';
import { memo } from 'react';
import { leftSideContainerSx } from '../styles/createCampaign';
import { UpdateExistingCitations } from './UpdateExistingCitations';
import { DuplicateCitations } from './DuplicateCitations';
import { AvailableNewCitations } from './AvailableNewCitations';
import { SyncAndPost } from './SyncAndPost';

export const CampaignLeftSide = memo(() => {
  return (
    <Box sx={leftSideContainerSx}>
      <UpdateExistingCitations />
      <DuplicateCitations />
      <AvailableNewCitations />

      {/* Sync and Post */}

      {/* TODO: uncomment this when the sync and post feature is implemented */}
      {/* <SyncAndPost /> */}
    </Box>
  );
});
